/**
 * This file is the entrypoint of the lib to export all the components
 * that must be available for people that use lyriapay library.
 */

import LyriaPay from 'lib/components/LyriaPay';

export default LyriaPay;
